import React from "react";

// Dependency-free SVG donut. segments: [{ value, color, label }]
export function Donut({ segments, size = 148, thickness = 18, centerLabel, centerSub }) {
  const total = segments.reduce((s, x) => s + Math.max(0, x.value), 0) || 1;
  const r = (size - thickness) / 2;
  const c = 2 * Math.PI * r;
  let offset = 0;
  return (
    <div className="relative" style={{ width: size, height: size }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <g transform={`translate(${size / 2},${size / 2}) rotate(-90)`}>
          <circle r={r} fill="none" stroke="hsl(214 30% 92%)" strokeWidth={thickness} />
          {segments.map((s, i) => {
            const len = (Math.max(0, s.value) / total) * c;
            const el = (
              <circle key={i} r={r} fill="none" stroke={s.color} strokeWidth={thickness}
                strokeDasharray={`${len} ${c - len}`} strokeDashoffset={-offset} />
            );
            offset += len;
            return el;
          })}
        </g>
      </svg>
      {centerLabel && (
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
          <span className="font-display text-base font-bold text-slate-900">{centerLabel}</span>
          {centerSub && <span className="text-[11px] text-slate-400">{centerSub}</span>}
        </div>
      )}
    </div>
  );
}

// Stacked growth bars: invested (solid) + returns (light) per period.
export function GrowthBars({ data, valueKey = "value", baseKey = "invested" }) {
  const max = Math.max(...data.map((d) => d[valueKey]), 1);
  return (
    <div className="flex h-32 items-end gap-1" data-testid="growth-bars">
      {data.map((d, i) => {
        const base = d[baseKey] || 0;
        const value = d[valueKey] || 0;
        const investedPct = value > 0 ? (base / value) * 100 : 0;
        return (
          <div key={i} className="flex flex-1 flex-col justify-end" title={String(d.year ?? d.month ?? i + 1)}>
            <div className="flex w-full flex-col-reverse overflow-hidden rounded-t" style={{ height: `${(value / max) * 100}%` }}>
              <div className="bg-primary" style={{ height: `${investedPct}%` }} />
              <div className="bg-primary/30" style={{ height: `${100 - investedPct}%` }} />
            </div>
          </div>
        );
      })}
    </div>
  );
}

export function Legend({ items }) {
  return (
    <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5">
      {items.map((it, i) => (
        <span key={i} className="inline-flex items-center gap-1.5 text-xs text-slate-500">
          <span className="h-2.5 w-2.5 rounded-full" style={{ backgroundColor: it.color }} /> {it.label}
        </span>
      ))}
    </div>
  );
}
